function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.99997 16.17L4.82997 12L3.40997 13.41L8.99997 19L21 7.00003L19.59 5.59003L8.99997 16.17Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.64642 16.5236L8.99981 16.877L9.35336 16.5237L19.5898 6.29697L20.2929 7.00003L8.99997 18.2929L4.11833 13.4113L4.82873 12.7059L8.64642 16.5236Z",
  stroke: "black",
  strokeOpacity: 0.87
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M17 14L18.7678 15.7678",
  stroke: "black",
  strokeOpacity: 0.87
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M19.48 16.47L21.2477 18.2377",
  stroke: "black",
  strokeOpacity: 0.87
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M17 18.2427L21.2426 14",
  stroke: "black",
  strokeOpacity: 0.87
});

var SvgSaveClose = function SvgSaveClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSaveClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/SaveClose.0d48e69a.svg";
export { ForwardRef as ReactComponent };